import { helper } from "lib/helper";
import contact_usModel from "models/contact_us.model";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Table,
  Container,
  Row,
  Input,
  Button,
  UncontrolledTooltip
} from "reactstrap";
import AddModal from "views/components/AddModal";
// core components
import TablePagination from "views/components/TablePagination";

import { Link } from "react-router-dom";
import statesModel from "models/states.model";

const State = () => {
  const [modal, setModal] = useState(false);

  const toggleModal = (modalName) => {
    setModal(!modal);
  };

  const [isLoading, setIsLoading] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const parameters = {};
  for (let [key, value] of searchParams) {
    parameters[key] = value;
  }

  const getListData = async () => {
    setIsLoading(true);
    
    // Dummy data for Indian states
    const dummyStates = [
      { _id: "1", id: "1", name: "Andhra Pradesh" },
      { _id: "2", id: "2", name: "Arunachal Pradesh" },
      { _id: "3", id: "3", name: "Assam" },
      { _id: "4", id: "4", name: "Bihar" },
      { _id: "5", id: "5", name: "Chhattisgarh" },
      { _id: "6", id: "6", name: "Delhi" },
      { _id: "7", id: "7", name: "Goa" },
      { _id: "8", id: "8", name: "Gujarat" },
      { _id: "9", id: "9", name: "Haryana" },
      { _id: "10", id: "10", name: "Himachal Pradesh" },
      { _id: "11", id: "11", name: "Jharkhand" },
      { _id: "12", id: "12", name: "Karnataka" },
      { _id: "13", id: "13", name: "Kerala" },
      { _id: "14", id: "14", name: "Madhya Pradesh" },
      { _id: "15", id: "15", name: "Maharashtra" },
      { _id: "16", id: "16", name: "Manipur" },
      { _id: "17", id: "17", name: "Meghalaya" },
      { _id: "18", id: "18", name: "Mizoram" },
      { _id: "19", id: "19", name: "Nagaland" },
      { _id: "20", id: "20", name: "Odisha" },
      { _id: "21", id: "21", name: "Punjab" },
      { _id: "22", id: "22", name: "Rajasthan" },
      { _id: "23", id: "23", name: "Sikkim" },
      { _id: "24", id: "24", name: "Tamil Nadu" },
      { _id: "25", id: "25", name: "Telangana" },
      { _id: "26", id: "26", name: "Tripura" },
      { _id: "27", id: "27", name: "Uttar Pradesh" },
      { _id: "28", id: "28", name: "Uttarakhand" },
      { _id: "29", id: "29", name: "West Bengal" }
    ];
    
    setTimeout(() => {
      setIsLoading(false);
      setDataList(dummyStates);
      setCurrentPage(1);
      setPerPage(20);
    }, 1000);
  };

  useEffect(() => {
    getListData();
  }, [location]);

  const handleDel = async (delId) => {
    helper.sweetalert
      .confirm("Are you sure you want to delete this State", "info", true)
      .then((result) => {
        if (result.isConfirmed) {
          // Simulate delete operation
          setTimeout(() => {
            setDataList(prevData => prevData.filter(item => item.id !== delId));
            helper.sweetalert.toast("State deleted successfully", "success");
          }, 500);
        }
      });
  };
  const [searchQuery, setSearchQuery] = useState('');

  // Filter data based on the search query
  const filteredData = dataList?.filter(item =>
    item?.name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <Container className="px-4 py-7">
     
          <Row>
            <div className="col">
              <Card className="shadow">
                <CardHeader className="border-0 d-flex justify-content-between ">
                  <h3 className="mb-0">All State</h3>

                  <div className="d-flex flex-row">
                    {/* <i class="fa-solid fa-magnifying-glass"></i> */}
                    <Input
        className="mr-4"
        type="text"
        placeholder="Search"
        size="sm"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
                
                    <Button
                      size="sm"
                      to="/admin/city/addstate"
                      tag={Link}
                      style={{backgroundColor:"#080278",color:"white",border:"none"}}
                    >
                      +AddState
                    </Button>
                  </div>
                </CardHeader>

                <Table className="align-items-center table-flush" responsive>
        <thead className="thead-light">
          <tr>
            <th scope="col">SN.</th>
            <th scope="col">City Name</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        {!isLoading && (
          <tbody>
            {filteredData.length > 0 ? (
              filteredData
                .slice()
                .reverse()
                .map((item, index) => (
                  <tr key={item._id} style={{ cursor: "pointer" }}>
                    <td>{index + 1}</td>
                    <td>{item?.name || "-"}</td>
                    <td
                      className="p-0"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <UncontrolledTooltip placement="top" target="userTooltip">
                        Delete
                      </UncontrolledTooltip>
                      <p
                        style={{
                          marginLeft: "30px",
                          fontSize: "15px",
                          color: "red",
                          marginTop: "10px",
                        }}
                        onClick={() => handleDel(item.id)}
                        id="userTooltip"
                      >
                        <i className="fas fa-trash"></i>
                      </p>
                    </td>
                  </tr>
                ))
            ) : (
              <tr style={{ textAlign: "center" }}>
                <td colSpan="3" style={{ verticalAlign: "middle" }}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        )}
      </Table>
                <CardFooter className="py-4">
                  {/* <TablePagination
                    totalPages={parseInt(dataList?.meta?.total_page)}
                    currentPage={parseInt(dataList?.meta?.current_page)}
                    pageUrl="/admin/messages?"
                  /> */}
                </CardFooter>
              </Card>
            </div>
          </Row>
  

        <AddModal
          modal={modal}
          Name="Add6"
          toggle={toggleModal}
          title="Add Fare management"
        />
      </Container>
    </>
  );
};



export default State